export const SCROLL_START_OFFSET = 24;
export const TRANSPARENT_SCROLL_CLASS = 'site-header-transparent';
export const TRANSPARENT_INCLUDES_PAGES = ['home'];
export default class HeaderService {
    constructor() {
        this.body = document.body;
        this.header = document.querySelector('.site-header');
    }
    handleDocumentScroll() {
        var _a, _b;
        const transparentHeaderAllowed = TRANSPARENT_INCLUDES_PAGES.some((page) => { var _a; return (_a = this.body) === null || _a === void 0 ? void 0 : _a.classList.contains(page); });
        if (!transparentHeaderAllowed) {
            (_a = this.header) === null || _a === void 0 ? void 0 : _a.classList.remove(TRANSPARENT_SCROLL_CLASS);
            return;
        }
        const operationType = Math.floor(window.scrollY) > SCROLL_START_OFFSET ? 'add' : 'remove';
        (_b = this.header) === null || _b === void 0 ? void 0 : _b.classList[operationType]('active-scroll');
    }
    init() {
        if (!this.header || !this.header.classList.contains(TRANSPARENT_SCROLL_CLASS)) {
            return;
        }
        window.document.addEventListener('scroll', () => this.handleDocumentScroll());
        this.handleDocumentScroll();
    }
}
